module.exports = __webpack_public_path__ + "img/ic_close.a050b626.svg";